import { IFilterType } from '../../../../../core/types/ProfileTypes';
import { IOrderType } from '../../../../../core/types/OrderType';
import { AxiosPromise } from 'axios';
import BasePaginateService from '../../../../../core/services/BasePaginateService';
import qs from 'qs';
import {handleUrlPost} from "../../dropOff/utils/serviceUtils";

const ALL_PICKUPS_URL: string = 'account/basicList/pickUp/v2';
const PICKUP_URL: string = 'maintenance/pickUp';
const VALIDATE_PICKUP_NUMBER_NAME: string = 'account/validatePickUpNameNumber';

export class PickUpService extends BasePaginateService {
  constructor() {
    super('');
  }
  public getPaginateAll(
    page: number = 1,
    size: number = 10,
    orders: IOrderType[],
    filters: IFilterType[],
    search: string,
    url: string = '',
    other?: any
  ): AxiosPromise<any[]> {
    const params = {
      search,
      filters,
      pageable: {
        page,
        size,
        orders
      },
      ...other
    };
    return this.httpAxios
      .post(ALL_PICKUPS_URL, JSON.stringify(params), {
        params: { data: JSON.stringify(params) },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'brackets' });
        }
      })
      .then((response: any) => response)
      .catch(err => {
        throw err;
      });
  }
  public create(item: any, loadId?: string | number): AxiosPromise<any> {
    const url = handleUrlPost(PICKUP_URL, loadId)
    return this.httpAxios
      .post(url, item)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public update(item: any, loadId?: string | number): AxiosPromise<any> {
    const url = handleUrlPost(PICKUP_URL, loadId);
    return this.httpAxios
      .post(url, item)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public getAll(params: any): AxiosPromise<any[]> {
    const { filterCriteria } = params;
    const filterCriteriaEncoded = JSON.stringify(filterCriteria);
    return this.httpAxios
      .post(ALL_PICKUPS_URL, filterCriteriaEncoded)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public getById(id: string | number): AxiosPromise<any[]> {
    return this.httpAxios
      .get(`${PICKUP_URL}?id=${id}&isExcludeScenarios=true`)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public getItemTanks = (pickUpId: number, params: any) => {
    return this.httpAxios
      .get(`${PICKUP_URL}/tank/${pickUpId}`, { params })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  public validateNameAndNumber(item: any, accountId: number, commodity: number, layoutId: number): AxiosPromise<any[]> {
    return this.httpAxios
      .post(`${VALIDATE_PICKUP_NUMBER_NAME}/${accountId}/${commodity}/${layoutId}`, item)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }
}

const pickUpService = new PickUpService();

export default pickUpService;
